<script setup lang="ts">
/**
 * 공통 Signers 블록 ([[Signers]] 재현) — 실제 서명자 선택 UI. (OtcSigners 미러링.)
 * varKey 별로 서명자 배열을 ctx 에 저장(문서별 독립). Create Task 시 문서별 [[Signers]] 로 전달.
 * (Resignation 이 쓰는 SignersField 재사용.)
 */
import { computed, inject } from 'vue';
import { BONUS_DOC_CTX } from '../bonusContext';
import SignersField from '../../resignation/signers/SignersField.vue';
import type { SignerEntry } from '@/features/AI-documents/types/docGen.types';

const props = withDefaults(defineProps<{ varKey: string; boardLabel?: string }>(), { boardLabel: '' });
const ctx = inject(BONUS_DOC_CTX)!;
const signers = computed(() => ctx.signersOf(props.varKey));
function onUpdate(list: SignerEntry[]) { ctx.setSigners(props.varKey, list); }
</script>

<template>
  <SignersField
    :model-value="signers"
    :board-label="boardLabel"
    :var-key="varKey"
    :entity-cd="ctx.entityCd.value"
    @update:model-value="onUpdate"
  />
</template>
